<template>
  <div>
    <div
      class="regular"
      :class="{
        'text-center': nameCenter,
      }"
    >
      {{ name }}
    </div>
    <div
      class="text-black"
      :class="{
        'text-center': textCenter,
        bold: bold,
      }"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTupla',
  meta: {
    description: 'Componente para datos secuenciales personalizados.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    name: {
      type: String,
      default: '',
      meta: {
        description: 'Establece el nombre',
        example: 'Texto requerido',
      },
    },
    nameCenter: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Posiciona el nombre al centro',
        example: 'true',
      },
    },
    text: {
      type: [String, Number],
      default: '',
      meta: {
        description: 'Propiedad para el texto',
        example: 'true',
      },
    },
    bold: {
      type: Boolean,
      default: () => true,
      meta: {
        description: 'Control para mostrar texto en bold',
        example: 'true',
      },
    },
    textCenter: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Posiciona el elemnto al centro',
        example: 'true',
      },
    },
  },
};
</script>

<style scoped>
.text-black {
  color: #11291b;
}
</style>
